// Measures the sticky announcement bar and header, whatever height they wrap or resize to:
// --pet-announcement-height keeps the header just below the bar, and --pet-sticky-top is where
// sticky page bars (FAQ topics, collection chips) start so they sit below both.
(() => {
  const bar = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');
  const root = document.documentElement.style;
  const measure = () => {
    const barHeight = bar ? bar.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    root.setProperty('--pet-announcement-height', `${barHeight}px`);
    root.setProperty('--pet-sticky-top', `${barHeight + headerHeight}px`);
  };
  measure();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(measure);
    [bar, header].forEach((element) => element && observer.observe(element));
  }
})();
